<script setup>
import iconHunter   from '@/assets/images/models/hunter/hunter.jpg' 
import iconPatriot  from '@/assets/images/models/patriot/patriot.jpg' 
import iconPickup   from '@/assets/images/models/pickup/pickup.jpg' 
import iconProfi    from '@/assets/images/models/profi/profi.jpg' 
import icon236323   from '@/assets/images/models/profi/236323.jpg' 
import iconSGR      from '@/assets/images/models/sgr/sgr.jpg' 
import icon220695   from '@/assets/images/models/sgr/220695.jpg' 
import icon330365   from '@/assets/images/models/sgr/330365.jpg' 
import icon374195   from '@/assets/images/models/sgr/374195.jpg' 
import icon390945   from '@/assets/images/models/sgr/390945.jpg' 
import icon396223   from '@/assets/images/models/sgr/396223.jpg'
import icon390995   from '@/assets/images/models/sgr/390995.jpg' 
import iconUnknown  from '@/assets/images/models/unknown.jpg'

import vinDecoder from '@/helpers/vinDecoder'

const props = defineProps({
    vin: {
        type: String,
        required: false
    }
})

function carImage(vin) {

    const name = vinDecoder(vin).name
    const code = vinDecoder(vin).code
    let img

    if(name == 'hunter') {
        img = iconHunter
    } else if(name == 'patriot') {
        img = iconPatriot
    } else if(name == 'pickup') {
        img = iconPickup
    } else if(name == 'profi') {
        if(code) {
            switch(code) {
                case '236323': 
                case '236324': 
                    img = icon236323
                    break
                default: 
                    img = iconProfi
                    break
            }
        } else {
            img = iconProfi
        }
    } else if(name == 'sgr') {
        if(code) {
            switch(code) {
                case '128801': 
                case '128802': 
                case '220695': 
                    img = icon220695
                    break
                case '396223': 
                    img = icon396223
                    break
                case '330365': 
                    img = icon330365
                    break
                case '374195': 
                    img = icon374195
                    break
                case '390945': 
                    img = icon390945
                    break
                case '390995': 
                    img = icon390995
                    break
                default: 
                    img = iconSGR
                    break
            }
        } else {
            img = iconSGR
        }
    } else {
        img = iconUnknown
    }
    return img
}

</script>

<template>
    <img 
        :src="carImage(props.vin)" 
        alt="Car model preview" 
        class="uta-car-image"
    >
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/car/car-image';
</style>